import React from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

interface ImageViewerProps {
  images?: string[];
  imageUrl?: string;
  currentIndex?: number;
  onClose: () => void;
  onNext?: () => void;
  onPrev?: () => void;
}

const ImageViewer: React.FC<ImageViewerProps> = ({ images, imageUrl, currentIndex = 0, onClose, onNext, onPrev }) => {
  const items = images && images.length ? images : (imageUrl ? [imageUrl] : []);
  const index = currentIndex ?? 0;

  if (!items || items.length === 0) {
    return null;
  }

  const imageUrlCurrent = items[index];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50" onClick={onClose}>
      <div className="relative w-full h-full flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-white hover:text-gray-300 z-50"
          onClick={onClose}
        >
          <X size={32} />
        </button>

        {/* Previous Button */}
        {items.length > 1 && (
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 bg-black bg-opacity-50 rounded-full p-2 z-50"
            onClick={onPrev}
          >
            <ChevronLeft size={32} />
          </button>
        )}

        {/* Image */}
        <div className="max-w-4xl max-h-[90vh] flex items-center justify-center">
            <img src={imageUrlCurrent} alt={`Image ${index + 1} of ${items.length}`} className="max-w-full max-h-full object-contain rounded-lg" />
        </div>


        {/* Next Button */}
        {items.length > 1 && (
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 bg-black bg-opacity-50 rounded-full p-2 z-50"
            onClick={onNext}
          >
            <ChevronRight size={32} />
          </button>
        )}

        {/* Counter */}
        {items.length > 1 && (
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white text-lg bg-black bg-opacity-50 rounded-full px-4 py-1">
            {index + 1} / {items.length}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageViewer;